import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HQ } from './sportConfig';

export const safeHQReturn = value => typeof value === 'string'
  && /^\/(?:\?|$|(?:match|lineup|series|standings|tips|upcoming)(?:\?|$)|team\/[^/?#]+(?:\?|$))/.test(value)
  && !/[\\\u0000-\u001f]/.test(value) ? value : '';

export const safeSearchReturn = value => typeof value === 'string' && value.startsWith('/search/?')
  && !/[\\\u0000-\u001f]/.test(value) ? value : '';

export function returnTo(target, navigate, external = false) {
  const absolute = external ? target : target === "/" ? (window.SportsHQNavigation?.rootTarget(HQ.basename + "/") || HQ.basename + "/") : HQ.basename + target;
  if (window.SportsHQNavigation) {
    window.SportsHQNavigation.back(absolute, external ? undefined : () => navigate(target, {replace:true}));
  } else if (external) window.location.replace(target);
  else navigate(target, {replace:true});
}

export default function ReturnLink({to, children, external = false, ...props}) {
  const navigate = useNavigate();
  const onClick = event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    event.preventDefault(); returnTo(to, navigate, external);
  };
  return external ? <a {...props} href={to} onClick={onClick}>{children}</a>
    : <Link {...props} to={to} replace onClick={onClick}>{children}</Link>;
}
